import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useViewAccrual from 'src/hooks/useViewAccrual';
import { FormattedReportResponse } from 'src/services/useGetAccrualReportApi';

const ChildHeaderCell = (props: GridHeaderCellProps) => {
  const { accrualReport, setAccrualReport } = useViewAccrual();
  const isAllExpanded = useMemo(
    () =>
      !!accrualReport
        ?.find?.((glCode: FormattedReportResponse) => glCode.glCd === props.title)
        ?.pos?.every((po) => po.expanded),
    [accrualReport, props.title]
  );
  const handleHeaderCellExpand = useCallback(() => {
    setAccrualReport((prev) => {
      const prevItems = [...prev];
      const index = prevItems.findIndex((item) => item.glCd === props.title);
      prevItems[index] = {
        ...prevItems[index],
        pos: prevItems[index].pos.map((po) => ({ ...po, expanded: !isAllExpanded })),
      };
      return prevItems;
    });
  }, [isAllExpanded, props.title, setAccrualReport]);

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        title="Expand/Collapse All"
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
      />
    </th>
  );
};

export default ChildHeaderCell;
